import { Skeleton } from "../shared/Skeleton";

export interface ExpenseThisMonthCardProps {
  title?: string;
  subtext?: string;
  amount?: string;
  subTotal?: string;
  taxTotal?: string;
  amountLabel?: string;
  badgePrimary?: string;
  badgeSecondary?: string;
  showEst?: boolean;
  loading?: boolean;
  activePeriod?: "month" | "week";
  onPeriodChange?: (period: "month" | "week") => void;
}

export function ExpenseThisMonthCard({
  title = "BILLED THIS MONTH",
  subtext = "—",
  amount = "—",
  subTotal = "—",
  taxTotal = "—",
  amountLabel = "Est. Bills",
  badgePrimary = "This Month",
  badgeSecondary = "—",
  showEst = true,
  loading = false,
  activePeriod = "month",
  onPeriodChange,
}: ExpenseThisMonthCardProps) {
  const monthLabel =
    subtext && subtext !== "—" ? subtext.split(" · ")[0] || subtext : null;
  const showBreakup = subTotal !== "—" || taxTotal !== "—";

  if (loading) {
    return (
      <div className="flex w-72 flex-none flex-col items-start justify-between gap-4 min-w-0">
        <div className="flex flex-col items-start gap-2 w-full">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-56" />
        </div>
        <div className="flex flex-col items-start gap-2 w-full">
          <Skeleton className="h-10 w-28" />
          <Skeleton className="h-4 w-32" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-28 rounded-full" />
          <Skeleton className="h-9 w-20 rounded-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-72 flex-none flex-col items-start justify-between min-w-0">
      <div className="flex flex-col items-start gap-1">
        <span className="font-['Inter'] text-[20px] font-[700] leading-[24px] text-neutral-950 uppercase tracking-wider">
          {title}
        </span>
        {subtext !== "—" ? (
          activePeriod === "week" ? (
            <span className="text-body font-body text-neutral-500">
              {subtext}
            </span>
          ) : monthLabel ? (
            <span className="text-body font-body text-neutral-500">
              {monthLabel}
            </span>
          ) : null
        ) : null}
      </div>
      <div className="flex flex-col items-start gap-1">
        <div className="flex gap-2 items-baseline">
          <span className="font-['Inter'] text-[40px] font-[700] leading-[40px] text-neutral-900">
            {amount}
          </span>
          {showEst && (
            <span className="text-body-bold font-body-bold text-warning-600">
              est.
            </span>
          )}
        </div>
        {showBreakup && (
          <span className="text-[12px] leading-[16px] text-neutral-500">
            (Sub total: <span className="text-neutral-600">{subTotal}</span> ·
            Tax total: <span className="text-neutral-600">{taxTotal}</span>)
          </span>
        )}
        {/* <span className="text-body font-body text-neutral-500">
          {amountLabel}
        </span> */}
      </div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => onPeriodChange?.("month")}
          className={`flex items-center rounded-full border border-solid px-4 py-1.5 ${
            activePeriod === "month" ? "border-error-300" : "border-neutral-200"
          }`}
        >
          <span className="text-body-bold font-body-bold text-error-400">
            {badgePrimary}
          </span>
        </button>
        <button
          type="button"
          onClick={() => onPeriodChange?.("week")}
          className={`flex items-center rounded-full border border-solid px-4 py-1.5 ${
            activePeriod === "week" ? "border-error-300" : "border-neutral-200"
          }`}
        >
          <span className="text-body font-body text-neutral-500">
            {badgeSecondary}
          </span>
        </button>
      </div>
    </div>
  );
}
